import React from "react";
import { useMediaQuery } from "react-responsive";

const MemberTable = ({ columns, rows, isAllChecked, onCheckAll, renderCell }) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  if (isMobile) {
    return (
      <ul className="members">
        <li className="header">
          <label>
            <input type="checkbox" onChange={onCheckAll} checked={isAllChecked} />{" "}
            {isAllChecked ? "선택해제" : "전체선택"}
          </label>
        </li>
        {rows.map((row, idx) => (
          <li key={idx}>
            {columns.map((col) => {
              const isAction = col.key === "checkbox" || col.key === "invite" || col.key === "kick";
              return (
                <div key={col.key}>
                  {!isAction && <strong>{col.label}</strong>}
                  <div>{renderCell(row, col.key)}</div>
                </div>
              );
            })}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <table>
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.key}>
              {col.key === "checkbox" ? (
                <input type="checkbox" onChange={onCheckAll} checked={isAllChecked} />
              ) : (
                col.label
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx}>
            {columns.map((col) => (
              <td key={col.key}>{renderCell(row, col.key)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MemberTable;
